import { Notification, NotificationStatus } from '@copera/notification';
import { Divider, Stack, Typography } from '@mui/material';
import { Fragment, useEffect } from 'react';
import { useElementAppears } from 'src/hooks/useElementAppears';
import { useLocales } from 'src/locales';
import { useUpdateNotificationMutation } from '../shared/useUpdateNotificationMutation';
import { NotificationListItem } from './NotificationListItem';

type Props = {
  items: Notification[];
  notification: Notification;
  index: number;
  parentEl: HTMLDivElement | null;
  onClose: () => void;
};

export const NotificationListItemContainer = ({
  items,
  notification,
  index,
  parentEl,
  onClose,
}: Props) => {
  const { visible, refElement } = useElementAppears({ root: parentEl });
  const { updateNotification } = useUpdateNotificationMutation();
  const { translate } = useLocales();
  useEffect(() => {
    if (!visible || notification.status === 'read') return;
    updateNotification({
      id: notification._id || '',
      status: NotificationStatus.READ,
    });
  }, [visible, notification.status, notification._id, updateNotification]);

  return (
    <Fragment key={notification._id}>
      {items.at(index - 1)?.status === 'unread' &&
        notification.status === 'read' && (
          <>
            <Divider sx={{ borderColor: 'divider' }} />
            <Typography
              variant="subtitle2"
              sx={{ color: 'text.secondary', px: 2, py: 1.5 }}
            >
              {translate('shared.labels.before_that')}
            </Typography>
          </>
        )}
      <Stack ref={refElement}>
        <NotificationListItem item={notification} onClose={onClose} />
      </Stack>
    </Fragment>
  );
};
